import React, { Component } from "react";
import moment from "moment";
import ConfirmReservation from "../Modal/ConfirmReservation";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Table,
  Spinner,
} from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { connect } from "react-redux";
import {
  APIResponseActions,
  CurrentPermitActions,
  SuperAdminAction,
} from "../../Actions";
import CustomContentAlert, {
  regExForPhone,
  validations,
  validation_message,
} from "../helper";
import "react-perfect-scrollbar/dist/css/styles.css";
import CreditTable from "./CreditTable";
import isEqual from "lodash/isEqual";

class VisitorPermit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      residentList_: [],
      defaultMenuIsOpen: false,
      currentCredits: [],
      usedCredits: [],
      allocatedCredits: [],
      usedAllocatedCredits: [],
      loader: false,
      bookingSlots: [],
      confirm_isopen: false,
      confirm_data: {},
      first_name: "",
      last_name: "",
      country_code: "",
      contact_number: "",
      plate_number: "",
      showBookingError: false,
      dayList: {},
      isOpen: false,
      showError: true,
      data_parked: {},
      credit: this.props.credits,
      suite_id: this.props.suite_id,
      propertyId: this.props.property_id,
      userDetails:
        this.props.UserProfileDetails &&
        Object.keys(this.props.UserProfileDetails).length
          ? this.props.UserProfileDetails
          : this.props.semiAuthorizedUserProfile,
      user_type:
        this.props.user_type === undefined
          ? this.props.semiAuthorizedUserProfile?.user_type
          : this.props.user_type,
      availableSpots: this.props.available_spot,
      leftCredit: 0,
      creditLimit: 0,
      runningCredits: undefined,
      creditAllocated: 0,
      isFormValid: false,
      validFirstName: true,
      validLastName: true,
      validContactNumber: true,
      validPlateNumber: true,
      validSuite_id: true,
      appConfig: this.props.appConfig,
      show_alert: false,
      api_success_message: "",
      show_error_on_get_resident_credit_summary: true,
      emptying_form: false,
      hideMsg: false,
      credit_alert: false,
      credit_msg: "",
      isSubmitted: false,
      time_slot: [],
      date_slot: [],
      credit_30days_reports: [],
      permit_credit_group: [],
      credit_type: null,
      day_availablity: this.props.day_availablity,
      evening_availability: this.props.evening_availability,
      night_availability: this.props.night_availability,
      single_credit_availability: {},
      api_error_message: "",
      show_alert_on_error: true,
      property: this.props.property,
      template: "",
      total_credit: 0,
      selected_suite_id: "",
      searchedSuiteId: "",
      isLoading: false,
      redirect_from: "",
      image: "",
      lpn: "",
      isPlateApproved: false,
      plateData: null,
      scan_time: 0,
      email: "",
      creditLimitMessage: "",
      showAsyncHead: false,
      phoneErrorMessage: "",
      isButtonDisable: true,
      multiplePermits: this.props.multiple_permits,
      isOpenDateList: false,
      country_code_list: [
        { text: "+1", value: "+1" },
        { text: "+91", value: "+91" },
        { text: "+44", value: "+44" },
        { text: "+61", value: "+61" },
      ],
      phone_options: [],
    };
  }

  componentDidMount = async () => {
    if (this.state.user_type === "unit") {
      if (this.props.property === undefined) {
        await this.props.getCreditTemplateGroups(
          this.props.semiAuthorizedUserProfile?.property?.template_id
        );
      } else {
        await this.props.getCreditTemplateGroups(
          this.props.property?.template_id
        );
      }
      const { propertyId, availableSpots, credit, userDetails } = this.state;
      const suite_id = this.state.suite_id
        ? this.state.suite_id
        : this.props.semiAuthorizedUserProfile?.suite_id;
      this.setState({ loader: true, isOpenDateList: true }, async () => {
        if (propertyId === undefined) {
          await this.props.getCurrentPermits(
            this.props?.semiAuthorizedUserProfile?.property_id,
            availableSpots,
            credit,
            suite_id
          );
        } else {
          await this.props.getCurrentPermits(
            propertyId,
            availableSpots,
            credit,
            suite_id
          );
        }
        await this.props.getTimeSlot(suite_id);
        this.setState({
          dayList: this.props.data_parked ? this.props.data_parked : {},
          data_parked: this.props.data_parked ? this.props.data_parked : {},
          time_slot:
            this.props.time_slot && this.props.time_slot.length
              ? this.props.time_slot
              : [],
          date_slot:
            this.props.date_slot && this.props.date_slot.length
              ? this.props.date_slot
              : [],
          credit_used_30days:
            this.props.credit_used_30days &&
            this.props.credit_used_30days.length
              ? this.props.credit_used_30days
              : "",
          credit_30days_reports:
            this.props.credit_30days_reports &&
            this.props.credit_30days_reports.length
              ? this.props.credit_30days_reports
              : [],
          credit_type:
            this.props.credit_type === undefined
              ? this.props?.semiAuthorizedUserProfile?.credit_type
              : this.props.credit_type,
          day_availablity: this.props.day_availablity,
          evening_availability: this.props.evening_availability,
          night_availability: this.props.night_availability,
          single_credit_availability: this.props?.single_credit_availability,
          template: this.props?.property?.credit_group,
          multiplePermits: this.props.multiple_permits,
        });
        this.props.setResidentCredits(userDetails);
        this.props.getResidents(userDetails);
        this.getResidentCreditSummary(suite_id, propertyId, credit);
        this.setState({ loader: false, showError: this.props.api_response });
      });
    } else if (
      this.state.user_type === "admin" ||
      this.state.user_type === "superadmin"
    ) {
      if (this.props.location && this.props.location.state) {
        const lpn = this.props.location.state.lpn;
        const redirect_from = this.props.location.state.redirect_from;
        const image = this.props.location.state.image;
        const email = this.props.location.state.email;
        const scan_time = this.props.location.state.scan_time;
        const isPlateApproved = this.props.location.state.isPlateApproved;
        const _plateData = this.props.location.state.data;
        const plateData =
          _plateData && Object.keys(_plateData).length ? _plateData : null;
        this.setState({
          plate_number: lpn,
          redirect_from: redirect_from,
          isPlateApproved: isPlateApproved,
          image: image,
          lpn: lpn,
          plateData: plateData,
          scan_time: scan_time,
          email: email,
          multiplePermits: this.props.multiple_permits,
        });
      }
    }
    const selectedPropertyName = this.state.property?.property_name;
    const selectedDomainName = this.state.property?.domain;
    await this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
    await this.props.fetchResidentList();
    this.setState({ showAsyncHead: true });
    if (this.props.api_response) {
      this.setState(
        {
          residentList_: this.props.residentList,
        },
        () => this.filterResident()
      );
    }
    this.setState({
      credit: this.props.credits,
    });
    // return newList;
  };

  getResidentCreditSummary = (credit) => {
    this.setState(
      { usedAllocatedCredits: this.props.usedAllocatedCredits },
      () => {
        let allocatedCredits = this.state.usedAllocatedCredits;
        if (allocatedCredits && allocatedCredits.length) {
          allocatedCredits = allocatedCredits[0].cost;
        } else {
          allocatedCredits = 0;
        }
        const usedCredits = parseInt(allocatedCredits);

        this.setState({ currentCredits: this.props.currentCredits }, () => {
          const allocatedCredits = this.state.currentCredits;
          let creditAllocated = credit;
          if (allocatedCredits && allocatedCredits.length) {
            creditAllocated = parseInt(allocatedCredits[0].cost);
          } else {
            creditAllocated = 0;
          }
          let leftCredit = credit - creditAllocated;
          let creditLimit = 0;
          if (this.state.credit_type === "single") {
            const credit_available =
              this.state.single_credit_availability &&
              this.state.single_credit_availability.credit_available;
            leftCredit = credit_available;
            creditLimit = credit;
          } else {
            const credit =
              this.props.day + this.props.evening + this.props.night;
            const credit_available =
              this.state.credit_30days_reports &&
              this.state.credit_30days_reports.length &&
              this.state.credit_30days_reports
                .map((item) => item.credit_available)
                .reduce((prev, curr) => prev + curr, 0);
            leftCredit = credit_available;
            creditLimit = credit;
          }
          console.log("check the leftcredit", leftCredit);
          this.setState({
            leftCredit,
            creditLimit,
            runningCredits: usedCredits,
            creditAllocated,
          });
          this.setState({ usedCredits: this.props.usedCredits });
          this.setState({
            allocatedCredits: this.props.allocatedCredits,
          });
        });
      }
    );
    this.setState({
      show_error_on_get_resident_credit_summary: this.props.api_response,
    });
    // });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data_parked !== this.props.data_parked) {
      this.setState({
        data_parked: this.props.data_parked,
        showError: this.props.api_response,
      });
    }
    if (prevProps.usedAllocatedCredits !== this.props.usedAllocatedCredits) {
      this.setState({
        usedAllocatedCredits: this.props.usedAllocatedCredits,
        showError: this.props.api_response,
      });
    }
    if (
      prevProps.single_credit_availability !==
      this.props.single_credit_availability
    ) {
      this.setState({
        single_credit_availability: this.props.single_credit_availability,
        showError: this.props.api_response,
      });
    }
    if (prevProps.currentCredits !== this.props.currentCredits) {
      this.setState({
        currentCredits: this.props.currentCredits,
        showError: this.props.api_response,
      });
    }
    if (prevProps.usedCredits !== this.props.usedCredits) {
      this.setState({
        usedCredits: this.props.usedCredits,
        showError: this.props.api_response,
      });
    }
    if (prevProps.allocatedCredits !== this.props.allocatedCredits) {
      this.setState({
        allocatedCredits: this.props.allocatedCredits,
        showError: this.props.api_response,
      });
    }
    if (
      !isEqual(
        prevProps.credit_30days_reports,
        this.props.credit_30days_reports
      )
    ) {
      this.setState({
        credit_30days_reports: this.props.credit_30days_reports,
        showError: this.props.api_response,
      });
    }
    if (
      !isEqual(
        prevProps.single_credit_availability,
        this.props.single_credit_availability
      )
    ) {
      this.setState({
        single_credit_availability: this.props.single_credit_availability,
        showError: this.props.api_response,
      });
    }
    if (!isEqual(prevProps.credit_used_30days, this.props.credit_used_30days)) {
      this.setState({
        credit_used_30days: this.props.credit_used_30days,
        showError: this.props.api_response,
      });
    }
    if (!isEqual(prevProps.UserProfileDetails, this.props.UserProfileDetails)) {
      this.setState({
        userDetails: this.props.UserProfileDetails,
        showError: this.props.api_response,
      });
    }
  }

  handleCheckBox = (keys, columnIndex, item) => {
    const selectedId = +item.id;
    let limit = 0;
    let tempId;
    const { dayList, leftCredit } = this.state;
    dayList[keys][columnIndex].isChecked =
      !dayList[keys][columnIndex].isChecked;
    const _credit = this.state.credit;
    let credit =
      _credit === undefined
        ? this.props.semiAuthorizedUserProfile?.credits
        : _credit;
    if (item.isChecked) {
      // && credit > 0
      const globalCredit =
        this.props.globaleCredit === undefined
          ? this.props.semiAuthorizedUserProfile?.credits
          : this.props.globaleCredit;
      if (globalCredit === +credit) {
        // globalecredit:30
        if (+credit >= leftCredit) {
          limit = selectedId + leftCredit - 1;
        } else {
          limit = selectedId + credit - 1;
        }
        Object.keys(dayList).forEach((keys) => {
          dayList[keys].forEach((value) => {
            const valueId = +value.id;
            if (valueId === selectedId) {
              credit--;
              value.isChecked = true;
              value.isDisabled = false;
              this.setState({ hideMsg: true });
              const permitGroup = {
                group_name: item.group_name,
                begin_time: item.startDate,
                expire_time: item.endDate,
                credits: item.credits,
                id: item.id,
              };
              const joined = this.state.permit_credit_group.concat(permitGroup);
              this.setState({ permit_credit_group: joined });
            }
            if (valueId > selectedId && valueId <= limit && value.isBooked) {
              tempId = valueId;
            }
            if (valueId < selectedId || valueId > (tempId || limit)) {
              value.isChecked = false;
              value.isDisabled = true;
            }
          });
        });
      } else {
        limit = selectedId;
        Object.keys(dayList).forEach((dayListKeys) => {
          dayList[dayListKeys].forEach((value) => {
            const valueId = +value.id;
            if (
              valueId <= limit &&
              !value.isChecked &&
              !value.isDisabled &&
              !value.isBooked
            ) {
              credit--;
              value.isChecked = true;
              value.isDisabled = false;
              this.setState({ hideMsg: true });
              const permitGroup = {
                group_name: value.group_name,
                begin_time: value.startDate,
                expire_time: value.endDate,
                credits: value.credits,
                id: value.id,
              };
              const permit_credit_group = this.state.permit_credit_group;
              const joined = permit_credit_group.push(permitGroup);
              this.setState({ permit_credit_group: joined });
            }
            if (valueId === selectedId) {
              credit--;
              value.isChecked = true;
              value.isDisabled = false;
              this.setState({ hideMsg: true });

              const permitGroup = {
                group_name: value.group_name,
                begin_time: value.startDate,
                expire_time: value.endDate,
                credits: value.credits,
                id: value.id,
              };

              const joined = this.state.permit_credit_group.concat(permitGroup);
              this.setState({ permit_credit_group: joined });
            }
          });
        });
      }
    } else {
      if (!item.isChecked) {
        const id = item.id;
        const checkedSlots = JSON.parse(
          JSON.stringify(this.state.permit_credit_group)
        );
        checkedSlots.pop();
        const clickedIdObj = checkedSlots.find((slot) => slot.id === id);
        const isIdExist = !!(clickedIdObj && Object.keys(clickedIdObj).length);

        if (!isIdExist) {
          const updated_permit_credit_group = (
            this.state.permit_credit_group ?? []
          ).filter((el) => el.id !== id);

          this.setState({
            permit_credit_group: updated_permit_credit_group,
          });
        }
      }

      this.setState({ hideMsg: true });
      const checkNextSelected = []; // why?
      const checkIsSelectedExist = [];
      Object.keys(dayList).forEach((_keys) => {
        dayList[_keys].forEach((_item) => {
          const itemId = +_item.id;
          if (itemId > selectedId && _item.isChecked) {
            checkNextSelected.push(_item);
          } else if (_item.isChecked) {
            this.setState({ hideMsg: true });
            checkIsSelectedExist.push(_item);
          }
        });
      });
      if (checkNextSelected.length > 0) {
        // when does it run?
        item.isChecked = true;
        return false;
      } else {
        credit++;
        tempId = undefined;
      }

      if (checkIsSelectedExist.length === 0) {
        Object.keys(dayList).forEach((key) => {
          dayList[key].forEach((value) => {
            value.isDisabled = false;
            this.setState({ hideMsg: true });
          });
        });
      }
    }
    this.validateVisitorPermitForm();
    this.setState({ dayList, credit });
  };

  handleCreateReservation = () => {
    let {
      dayList,
      showBookingError,
      first_name,
      last_name,
      plate_number,
      country_code,
      contact_number,
      bookingSlots,
      leftCredit,
      phone_options,
    } = this.state;
    if (leftCredit > 0) {
      bookingSlots = [];
      Object.keys(dayList).forEach((keys) => {
        dayList[keys].forEach((value) => {
          if (value.isChecked) {
            bookingSlots.push(value);
          } else {
            this.setState({ hideMsg: false });
          }
        });
      });
      setTimeout(() => {
        Object.keys(dayList).forEach((keys) => {
          dayList[keys].forEach((value) => {
            value.isDisabled = false;
            if (value.isChecked) {
              value.isChecked = !value.isChecked;
            }
          });
        });
      }, 1000);
      if (bookingSlots.length === 0) {
        showBookingError = true;
        this.setState({ showBookingError });
      } else {
        showBookingError = false;
        this.setState({ showBookingError });
      }

      if (bookingSlots.length) {
        const { permit_credit_group } = this.state;
        const displayStartTime = moment(
          permit_credit_group[0].begin_time
        ).format("lll");
        const displayEndTime = moment(
          permit_credit_group[permit_credit_group.length - 1].expire_time
        ).format("lll");
        if (this.state.credit_type === "single") {
          const total_credit = this.state.permit_credit_group.reduce(
            (acc, el) => {
              return acc + parseInt(el.credits);
            },
            0
          );
          if (total_credit <= leftCredit) {
            const data = {
              title: "Confirm Visitor Reservation",
              firstName: first_name,
              lastName: last_name,
              plateNumber: plate_number,
              country_code: country_code,
              phone: contact_number,
              phone_options: phone_options,
              startTime: displayStartTime,
              endTime: displayEndTime,
              usedCredits: total_credit,
              multiplePermits: this.state.multiplePermits,
            };
            this.setState({
              confirm_data: data,
              confirm_isopen: true,
              bookingSlots,
              total_credit: total_credit,
            });
          } else {
            this.setState({
              credit_alert: true,
              credit_msg:
                "please check your credits and select the slots again",
              credit: this.props.credits,
              permit_credit_group: [],
            });
            Object.keys(dayList).forEach((keys) => {
              dayList[keys].forEach((value) => {
                value.isDisabled = false;
                if (value.isChecked) {
                  value.isChecked = !value.isChecked;
                }
              });
            });
            setTimeout(() => {
              this.setState({
                credit_alert: false,
                credit_msg: "",
              });
            }, 4000);
          }
        } else {
          let allCreditObj = {};
          let totalCredit = 0;
          this.props.templateCreditGroup.map((item) => {
            const tempCredit = this.state.permit_credit_group.reduce(
              (sum, el) => {
                if (el.group_name === item) {
                  return sum + parseInt(el.credits);
                } else {
                  return sum;
                }
              },
              0
            );
            allCreditObj = {
              ...allCreditObj,
              [item]: tempCredit,
            };
            totalCredit = totalCredit + tempCredit;
            return item;
          });

          const creditValidityArray = [];
          this.state.credit_30days_reports.forEach((item) => {
            if (allCreditObj[item.slot] <= item.credit_available) {
              creditValidityArray.push(true);
            } else {
              creditValidityArray.push(false);
            }
          });
          if (!creditValidityArray.includes(false)) {
            const data = {
              title: "Confirm Visitor Reservation",
              firstName: first_name,
              lastName: last_name,
              plateNumber: plate_number,
              country_code: country_code,
              phone_options: phone_options,
              phone: contact_number,
              startTime: displayStartTime,
              endTime: displayEndTime,
              usedCredits: totalCredit,
              multiplePermits: this.state.multiplePermits,
            };
            this.setState({
              confirm_data: data,
              confirm_isopen: true,
              bookingSlots,
              total_credit: totalCredit,
            });
          } else {
            this.setState({
              credit_alert: true,
              credit_msg:
                // credit_limit_error_message +
                "please check your credits and select the slots again",
              credit: this.props.credits,
              permit_credit_group: [],
            });
            Object.keys(dayList).forEach((keys) => {
              dayList[keys].forEach((value) => {
                value.isDisabled = false;
                if (value.isChecked) {
                  value.isChecked = !value.isChecked;
                }
              });
            });
            setTimeout(() => {
              this.setState({
                credit_alert: false,
                credit_msg: "",
              });
            }, 4000);
          }
        }
      }
    }
  };

  handlePhoneOptions = (index, value, type) => {
    console.log("index, value :::::", index, value, type);

    const { phone_options } = this.state;

    let phone_values;
    let country_code_values;

    if (type === "phone_number_options") {
      phone_values = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
      phone_options[index].phone = phone_values;
    }
    if (type === "country_code_options") {
      country_code_values = value;
      phone_options[index].country_code = country_code_values;
    }

    this.setState(
      {
        phone_options: [...phone_options],
      },
      async () => {
        this.validateVisitorPermitForm();
      }
    );
  };

  removePhoneOption = (index) => {
    const { phone_options } = this.state;
    console.log("index", index);

    this.setState(
      {
        phone_options: [...phone_options.filter((_x, i) => i !== index)],
      },
      async () => {
        this.validateVisitorPermitForm();
      }
    );
  };

  handleAddPhoneOptions = () => {
    const { phone_options } = this.state;

    this.setState(
      {
        phone_options: [...phone_options, { country_code: "+1", phone: "" }],
      },
      async () => {
        this.validateVisitorPermitForm();
      }
    );
  };

  isMultiplePhoneValid = () => {
    const { phone_options } = this.state;

    const validPhone = phone_options?.map((options) => {
      if (
        options.phone?.trim().length > 10 ||
        options.phone?.trim().length < 10 ||
        options.phone?.trim().length === 0
      ) {
        return !(
          options.phone.trim().length > 10 ||
          options.phone.trim().length < 10 ||
          options.phone.trim().length === 0
        );
      }
      return true;
    });
    return !validPhone.includes(false);
  };

  multiplePhoneRender = (phone_options, country_code_list) => {
    return (
      phone_options &&
      typeof phone_options === "object" &&
      Array.isArray(phone_options) &&
      phone_options.map((option, index) => {
        return (
          <Row key={option?.country_code} className="my-0">
            <Col className="" md="3">
              <Form.Group>
                <Form.Control
                  as="select"
                  name="country_code_options"
                  onChange={(e) =>
                    this.handlePhoneOptions(
                      index,
                      e.target.value,
                      "country_code_options"
                    )
                  }
                  value={option?.country_code}
                  required
                >
                  {country_code_list ? (
                    <>
                      {country_code_list.map((item) => (
                        <option key={item.text} value={item.value}>
                          {item.text}
                        </option>
                      ))}
                    </>
                  ) : null}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col className="" md="3">
              <Form.Group className="p-0 m-1">
                {/* <Form.Label>Option {index + 1}</Form.Label> */}
                {/* <span className="asterisk">*</span> */}
                <Form.Control
                  placeholder="Phone Number"
                  type="text"
                  name="phone_number_options"
                  value={option?.phone}
                  // onBlur={(e) => e.target.value.trim() === "" && removeNoteOption(index)}
                  onChange={(e) =>
                    this.handlePhoneOptions(
                      index,
                      e.target.value,
                      "phone_number_options"
                    )
                  }
                  maxLength="10"
                  autoComplete="off"
                />
              </Form.Group>
            </Col>
            <Col md="3" className="mt-2">
              <Button
                size="sm"
                className="ml-2"
                onClick={() => this.removePhoneOption(index)}
              >
                <i className="fas fa-minus"></i>
              </Button>
            </Col>
          </Row>
        );
      })
    );
  };

  handleChange = ({ target }) => {
    const prevstate = this.state.contact_number;
    this.setState(
      { [target.name]: target.value, showBookingError: false },
      async () => {
        if (this.state.contact_number.trim().length) {
          this.validateContactNumber();
        }
        if (
          target.name === "contact_number" &&
          this.state.contact_number.trim().length
        ) {
          if (regExForPhone.test(this.state.contact_number)) {
            this.setState({ contact_number: target.value });
          } else {
            this.setState({ contact_number: prevstate });
          }
        }
        this.validateVisitorPermitForm();
        switch (target.name) {
          case "contact_number": {
            if (this.state.contact_number.trim().length) {
              if (regExForPhone.test(this.state.contact_number)) {
                this.setState({ contact_number: target.value });
              } else {
                this.setState({ contact_number: prevstate });
              }
            } else {
              const CN = validations(
                target.name,
                "contact_number",
                this.state.contact_number
              );
              this.setState({
                contact_number: CN.value,
                validContactNumber: CN.validator,
              });
            }
            break;
          }
          case "country_code": {
            this.setState({
              country_code: target.value.replace(/[a-zA-Z]/, ""),
            });
            break;
          }
          case "first_name": {
            const FN = validations(
              target.name,
              "first_name",
              this.state.first_name
            );
            this.setState({
              first_name: FN.value,
              validFirstName: FN.validator,
            });
            break;
          }
          case "last_name": {
            const LN = validations(
              target.name,
              "last_name",
              this.state.last_name
            );
            this.setState({
              last_name: LN.value,
              validLastName: LN.validetor,
            });
            break;
          }
          case "plate_number": {
            const PN = validations(
              target.name,
              "plate_number",
              this.state.plate_number
            );
            this.setState({
              plate_number: PN.value.toUpperCase().replace(/[^a-zA-Z0-9]/g, ""),
              validPlateNumber: PN.validetor,
            });
            break;
          }
          case "suite_id": {
            const SI = validations(
              target.name,
              "suite_id",
              this.state.suite_id
            );
            this.setState({
              suite_id: SI.value,
              validSuite_id: SI.validetor,
            });
            break;
          }
        }
      }
    );
  };

  validateVisitorPermitForm = () => {
    if (this.state.user_type !== "unit") {
      if (
        this.state.first_name.trim().length &&
        this.state.last_name.trim().length &&
        this.state.contact_number.trim().length &&
        this.state.plate_number.trim().length &&
        this.state.selected_suite_id.trim().length &&
        this.validateContactNumber() &&
        this.isMultiplePhoneValid()
      ) {
        this.setState({
          isFormValid: true,
        });
      } else {
        this.setState({
          isFormValid: false,
        });
      }
    } else {
      if (
        this.state.first_name.trim().length &&
        this.state.last_name.trim().length &&
        this.state.contact_number.trim().length &&
        this.state.plate_number.trim().length &&
        this.validateContactNumber() &&
        this.isMultiplePhoneValid()
      ) {
        this.setState({
          isFormValid: true,
        });
      } else {
        this.setState({
          isFormValid: false,
        });
      }
    }
  };

  validateContactNumber = () => {
    const { contact_number } = this.state;
    const regExForContactNumber = regExForPhone;
    const isContactNumberValidate = regExForContactNumber.test(
      String(contact_number)
    );
    if (isContactNumberValidate) {
      if (
        (contact_number && contact_number.length >= 11) ||
        (contact_number && contact_number.length < 10)
      ) {
        this.setState({
          phoneErrorMessage: "Please enter valid phone number",
        });
        return false;
      } else {
        this.setState({
          phoneErrorMessage: "",
        });
        return true;
      }
    } else {
      return false;
    }
  };

  handleToogle = () => {
    this.setState({
      confirm_isopen: !this.state.confirm_isopen,
      credit: this.props.credits,
      permit_credit_group: [],
    });
  };

  getCreditsDetails = (suite_id, propertyId) => {
    this.props.getCreditsIndividualDetails(suite_id, propertyId).then(() => {
      this.setState({
        allocatedCredits: this.props.allocatedCredits,
        showError: this.props.api_response,
        credit: this.props.credits,
      });
    });
  };

  handleSubmit = async () => {
    const current_credit = this.state.leftCredit - this.state.total_credit;
    const newAllocated = this.state.creditAllocated + this.state.total_credit;
    this.setState(
      {
        loader: true,
        emptying_form: true,
        isFormValid: false,
        leftCredit: current_credit,
        creditAllocated: newAllocated,
        isSubmitted: true,
        isButtonDisable: false,
      },
      async () => {
        const timezone = this.props?.timezone
          ? this.props.timezone
          : this.props.semiAuthorizedUserProfile?.timezone;
        await this.props.AddPermits(
          this.state.bookingSlots,
          this.state.confirm_data,
          this.state.userDetails,
          this.state.permit_credit_group,
          this.state.credit_type,
          timezone
        );
        const propertyId = this.state.propertyId
          ? this.state.propertyId
          : this.props?.semiAuthorizedUserProfile?.property_id;
        if (this.state.user_type === "unit") {
          const suite_id = this.state.suite_id
            ? this.state.suite_id
            : this.props.semiAuthorizedUserProfile?.suite_id;
          this.getCreditsDetails(suite_id, propertyId);
        }
        if (
          this.state.user_type === "admin" ||
          this.state.user_type === "superadmin"
        ) {
          const { selected_suite_id: suite_id } = this.state;
          this.getCreditsDetails(suite_id, propertyId);
        }
        if (this.props.api_response) {
          this.setState({
            loader: false,
            showError: this.props.api_response,
            show_alert: true,
            api_success_message: this.props.api_success_message,
            permit_credit_group: [],
            first_name: "",
            last_name: "",
            plate_number:
              this.props.location?.state && this.props.location?.state.lpn
                ? this.props.location?.state.lpn
                : "",
            country_code: "",
            contact_number: "",
            selectedValue: {},
            phone_options: [],
          });
          setTimeout(() => {
            this.setState({
              show_alert: false,
              api_success_message: "",
              showError: "",
            });
          }, 1000);
        } else {
          this.setState({
            loader: false,
            showError: this.props.api_response,
            api_error_message: this.props.api_error_message,
            show_alert_on_error: this.props.api_response,
            permit_credit_group: [],
          });
        }

        this.handleToogle();
        setTimeout(() => {
          const { redirect_from } = this.state;
          this.setState({
            show_alert: false,
            show_alert_on_error: true,
            isButtonDisable: true,
          });

          if (redirect_from === "plate-check") {
            const history = require("../../history").default;
            history.push({
              pathname: `/plate-check`,
              state: {
                image: this.state.image,
                lpn: this.state.lpn,
                email: this.state.email,
                scan_time: this.state.scan_time,
                isPlateApproved: this.props.api_response,
              },
            });
          }
        }, 4000);
      }
    );
  };

  handleInputSelect = async (e) => {
    this.setState(
      {
        selected_suite_id: e.value,
        selectedValue: {
          value: e.value,
          label: e.label,
        },
        isOpenDateList: true,
        credit: this.props.credits,
      },
      async () => {
        const {
          selected_suite_id,
          propertyId,
          availableSpots,
          credit,
          userDetails,
        } = this.state;
        const newUserDetails = {
          ...userDetails,
          suite_id: selected_suite_id,
        };
        this.setState({
          userDetails: newUserDetails,
        });
        if (
          this.state.first_name.trim().length &&
          this.state.last_name.trim().length &&
          this.state.contact_number.trim().length &&
          this.state.plate_number.trim().length &&
          this.state.selected_suite_id.trim().length &&
          this.validateContactNumber()
        ) {
          this.setState({
            isFormValid: true,
          });
        } else {
          this.setState({
            isFormValid: false,
          });
        }
        if (propertyId === undefined) {
          await this.props.getCurrentPermits(
            this.props?.semiAuthorizedUserProfile?.property_id,
            availableSpots,
            credit,
            selected_suite_id
          );
        } else {
          await this.props.getCurrentPermits(
            propertyId,
            availableSpots,
            credit,
            selected_suite_id
          );
        }
        await this.props.getTimeSlot(selected_suite_id);
        const credit_type =
          this.props.credit_type === undefined
            ? this.props?.semiAuthorizedUserProfile?.credit_type
            : this.props.credit_type;
        console.log("credit type", credit_type);

        this.setState(
          {
            dayList: this.props.data_parked ? this.props.data_parked : {},
            data_parked: this.props.data_parked ? this.props.data_parked : {},
            time_slot:
              this.props.time_slot && this.props.time_slot.length
                ? this.props.time_slot
                : [],
            date_slot:
              this.props.date_slot && this.props.date_slot.length
                ? this.props.date_slot
                : [],
            credit_used_30days:
              this.props.credit_used_30days &&
              this.props.credit_used_30days.length
                ? this.props.credit_used_30days
                : "",
            credit_30days_reports:
              this.props.credit_30days_reports &&
              this.props.credit_30days_reports.length
                ? this.props.credit_30days_reports
                : [],
            credit_type: credit_type,
            single_credit_availability: this.props?.single_credit_availability,
            template: this.props?.property?.credit_group,
            multiplePermits: this.props.multiple_permits,
          },
          async () => {
            if (this.props.property === undefined) {
              await this.props.getCreditTemplateGroups(
                this.props.semiAuthorizedUserProfile?.property?.template_id
              );
            } else {
              await this.props.getCreditTemplateGroups(
                this.props.property?.template_id
              );
            }
            let day_availablity;
            let night_availability;
            let evening_availability;
            this.setState({
              day_availablity: day_availablity,
              night_availability: night_availability,
              evening_availability: evening_availability,
            });
          }
        );
        this.props.setResidentCredits(userDetails);
        this.props.getResidents(userDetails);
        this.getResidentCreditSummary(selected_suite_id, propertyId, credit);
        if (this.state.leftCredit <= 0) {
          this.setState({
            creditLimitMessage: "You don't have credit limit to add visitors",
          });
        }
      }
    );
  };

  filterResident = (selectd_suite_id) => {
    if (selectd_suite_id) {
      const searchResidentList = this.state.residentList_.filter(
        (selectResident) => {
          return selectResident.suite_id
            .toLowerCase()
            .includes(selectd_suite_id.toLowerCase());
        }
      );

      return (
        searchResidentList &&
        searchResidentList.length &&
        searchResidentList.map((item) => {
          return {
            value: item.suite_id,
            label: item.suite_id,
          };
        })
      );
    } else {
      if (this.state.residentList_ && this.state.residentList_.length) {
        return this.state.residentList_.map((item) => {
          return {
            value: item.suite_id,
            label: item.suite_id,
          };
        });
      } else {
        return [];
      }
    }
  };

  promiseOptions = async (inputValue) =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.filterResident(inputValue));
      }, 800);
    });

  visitorDelete = async (e) => {
    await this.props.visitorPermitDelete(e);
    const { propertyId, availableSpots, credit, selected_suite_id } =
      this.state;
    let suite_id = selected_suite_id;
    if (this.props.user_type === "unit") {
      suite_id = this.props.suite_id;
    }
    if (this.props.api_response) {
      this.setState({
        show_alert: true,
        api_success_message: this.props.api_success_message,
      });
      setTimeout(() => {
        this.setState({
          show_alert: false,
          api_success_message: "",
        });
      }, 4000);
    }
    if (propertyId === undefined) {
      await this.props.getCurrentPermits(
        this.props?.semiAuthorizedUserProfile?.property_id,
        availableSpots,
        credit,
        suite_id
      );
    } else {
      await this.props.getCurrentPermits(
        propertyId,
        availableSpots,
        credit,
        suite_id
      );
    }
    if (this.props.api_response) {
      this.setState({
        single_credit_availability: this.props?.single_credit_availability,
      });
    }
  };

  render() {
    const {
      isOpen,
      dayList,
      showBookingError,
      first_name,
      last_name,
      country_code,
      contact_number,
      plate_number,
      confirm_isopen,
      confirm_data,
      loader,
      usedCredits,
      allocatedCredits,
      leftCredit,
      creditLimit,
      runningCredits,
      creditAllocated,
      // suite_id,
      user_type,
      validFirstName,
      validLastName,
      validContactNumber,
      // validPlateNumber,
      // validSuite_id,
      api_success_message,
      show_alert,
      emptying_form,
      hideMsg,
      show_error_on_get_resident_credit_summary,
      credit_alert,
      credit_msg,
      credit_used_30days,
      credit_30days_reports,
      // credit_type,
      single_credit_availability,
      api_error_message,
      show_alert_on_error,
      selected_suite_id,
      country_code_list,
      phone_options,
      // isLoading,
    } = this.state;
    const time = this.props.time_slot; // FROm API(reducer)
    return (
      <div>
        <Container fluid>
          <Row>
            <Col md="12">
              <Card>
                <Card.Header style={{ backgroundColor: this.props.main_body }}>
                  {show_alert && (
                    <CustomContentAlert
                      delay={4000}
                      message={api_success_message}
                      className="toast-success"
                    />
                  )}
                  {!show_alert_on_error && (
                    <CustomContentAlert
                      delay={4000}
                      message={api_error_message}
                      className="toast-error"
                    />
                  )}
                  {!show_error_on_get_resident_credit_summary && (
                    <CustomContentAlert
                      delay={4000}
                      message={
                        "The server did not respond, Please try again after sometime"
                      }
                      className="toast-error"
                    />
                  )}
                  {credit_alert && (
                    <CustomContentAlert
                      delay={4000}
                      message={credit_msg}
                      className="toast-error"
                    />
                  )}
                  <Card.Title as="h4">Guest Reservation</Card.Title>
                </Card.Header>
                <Card.Body className="pos-rel-overflow-hide">
                  <CreditTable
                    isOpen={isOpen}
                    credit_type={
                      this.props.credit_type === undefined
                        ? this.state.credit_type
                        : this.props.credit_type
                    }
                    usedCredits={usedCredits}
                    allocatedCredits={allocatedCredits}
                    creditLimit={creditLimit}
                    dateRange={this.props.date_range}
                    runningCredits={runningCredits}
                    creditAllocated={creditAllocated}
                    leftCredit={leftCredit}
                    single_credit_availability={single_credit_availability}
                    credit_used_30days={credit_used_30days}
                    credit_30days_reports={credit_30days_reports}
                    handleButtonclick={() =>
                      this.setState({ isOpen: !this.state.isOpen })
                    }
                    visitorDelete={(e) => this.visitorDelete(e)}
                    isOpenDateList={this.state.isOpenDateList}
                    timezone={this.props.timezone}
                  />

                  <Form>
                    <Row>
                      {user_type !== "unit" ? (
                        <Col xl="3" lg="4" md="6" sm="12">
                          <Form.Group>
                            <label>
                              Unit your guest is visiting
                              <span className="asterisk">*</span>
                            </label>
                            <AsyncSelect
                              loadOptions={this.promiseOptions}
                              defaultOptions
                              cacheOptions
                              value={this.state.selectedValue}
                              onChange={(e) => this.handleInputSelect(e)}
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                    </Row>
                    <Row>
                      <Col xl="4" lg="4" md="6" sm="12">
                        <Form.Group className="mb-3">
                          <label>
                            First Name<span className="asterisk">*</span>
                          </label>
                          <Form.Control
                            placeholder="First Name"
                            type="text"
                            name="first_name"
                            value={first_name}
                            onChange={this.handleChange}
                            autoComplete="off"
                            disabled={loader}
                            required
                          ></Form.Control>
                          {!emptying_form &&
                            validation_message(
                              first_name,
                              "First Name",
                              validFirstName
                            )}
                        </Form.Group>
                      </Col>
                      <Col xl="4" lg="4" md="6" sm="12">
                        <Form.Group className="mb-3">
                          <label>
                            Last Name<span className="asterisk">*</span>
                          </label>
                          <Form.Control
                            placeholder="Last Name"
                            type="text"
                            name="last_name"
                            value={last_name}
                            onChange={this.handleChange}
                            disabled={loader}
                            autoComplete="off"
                            required
                          ></Form.Control>
                          {!emptying_form &&
                            validation_message(
                              last_name,
                              "Last Name",
                              validLastName
                            )}
                        </Form.Group>
                      </Col>
                      <Col xl="4" lg="4" md="6" sm="12">
                        <Form.Group className="mb-3">
                          <label>
                            License Plate Number
                            <span className="asterisk">*</span>
                          </label>
                          <Form.Control
                            placeholder="Plate Number"
                            type="text"
                            name="plate_number"
                            value={plate_number}
                            onChange={this.handleChange}
                            disabled={loader}
                            autoComplete="off"
                            maxLength="11"
                            required
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl="2" lg="4" md="6" sm="12">
                        <Form.Group className="mb-3">
                          <label>Country Code</label>
                          {/* <Form.Control
                            placeholder="Country Code"
                            type="text"
                            name="country_code"
                            value={country_code}
                            onChange={this.handleChange}
                            disabled={loader}
                            autoComplete="off"
                            required
                          ></Form.Control> */}
                          <Form.Control
                            as="select"
                            name="country_code"
                            onChange={this.handleChange}
                            value={country_code}
                            required
                          >
                            {country_code_list ? (
                              <>
                                {country_code_list.map((item) => (
                                  <option key={item.text} value={item.value}>
                                    {item.text}
                                  </option>
                                ))}
                              </>
                            ) : null}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="12">
                        <Form.Group className="mb-3">
                          <label>
                            Guest Contact Number
                            <span className="asterisk">*</span>
                          </label>
                          <Form.Control
                            placeholder="Contact Number"
                            type="text"
                            name="contact_number"
                            value={contact_number}
                            onChange={this.handleChange}
                            disabled={loader}
                            autoComplete="off"
                            required
                          ></Form.Control>
                          {!emptying_form &&
                            validation_message(
                              contact_number,
                              "Phone Number",
                              validContactNumber
                            )}
                          <span className="help-block">
                            {this.state.phoneErrorMessage}
                          </span>
                        </Form.Group>
                      </Col>
                      <Col md="2">
                        <Button
                          size="sm"
                          className="ml-3 mt-4"
                          disabled={
                            phone_options?.length > 9 ||
                            contact_number?.trim()?.length === 0 ||
                            contact_number?.trim()?.length > 10 ||
                            contact_number?.trim()?.length < 10 ||
                            !this.isMultiplePhoneValid()
                          }
                          onClick={this.handleAddPhoneOptions}
                        >
                          <i className="fas fa-plus-circle"></i>
                        </Button>
                      </Col>
                      <Col md="5"></Col>
                    </Row>
                    {
                      this.multiplePhoneRender(phone_options, country_code_list)
                      // Multiple phone render
                    }
                    <Row>
                      <Col md="12">
                        {showBookingError && !hideMsg ? (
                          <div className="mb-4">
                            <span className="help-block">
                              Please select atleast one spot for reservation
                            </span>
                          </div>
                        ) : null}
                        {!loader ? (
                          <div className="visitorPermit-controls mt-3 d-flex justify-content-end">
                            <Button
                              type="button"
                              className="btn-fill"
                              variant="primary"
                              // disabled={loader}
                              disabled={!this.state.isFormValid}
                              onClick={this.handleCreateReservation}
                            >
                              Make Reservation
                            </Button>
                          </div>
                        ) : (
                          <Spinner animation="border" variant="info" />
                        )}
                      </Col>
                    </Row>
                    {!loader && this.state.isOpenDateList && (
                      <div>
                        {dayList &&
                        Object.keys(dayList).length &&
                        leftCredit > 0 ? (
                          <Table
                            className="table-hover table-striped table-reservation mt-3 add-visitor-table"
                            responsive
                            bordered
                            size="sm"
                          >
                            <thead className="timing-header">
                              <tr>
                                <th> </th>
                                {time &&
                                  time.map((item, index) => (
                                    <th
                                      style={{
                                        color: "#000",
                                        fontSize: "11px",
                                      }}
                                      key={index}
                                    >
                                      {item.alias}
                                    </th>
                                  ))}
                              </tr>
                              <tr>
                                <th style={{ color: "#000" }}>Date</th>
                                {time &&
                                  time.map((item, index) => (
                                    <th key={index}>
                                      <span
                                        style={{
                                          color: "#bf8f00",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {item.time_to
                                          ? moment(item.time_from, [
                                              "HH:mm",
                                            ]).format("h:mm A")
                                          : "-"}
                                      </span>{" "}
                                      -{" "}
                                      <span
                                        style={{
                                          color: "#bf8f00",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {item.time_to
                                          ? moment(item.time_to, [
                                              "HH:mm",
                                            ]).format("h:mm A")
                                          : "-"}
                                      </span>{" "}
                                    </th>
                                  ))}
                              </tr>
                            </thead>
                            <tbody id="checkedBox">
                              {Object.entries(dayList).map(
                                ([keys, value], index) => {
                                  return (
                                    <tr key={index}>
                                      <td>
                                        <span className="font-14">{keys}</span>
                                      </td>
                                      {value.map((item, columnIndex) => {
                                        return (
                                          <td align="center" key={columnIndex}>
                                            <div className="custom-control custom-checkbox p-0">
                                              {item.isBooked ? (
                                                <span style={{ color: "red" }}>
                                                  Full
                                                </span>
                                              ) : (
                                                <>
                                                  <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id={
                                                      "tableDefaultCheck" +
                                                      columnIndex +
                                                      index
                                                    }
                                                    onChange={() =>
                                                      this.handleCheckBox(
                                                        keys,
                                                        columnIndex,
                                                        item
                                                      )
                                                    }
                                                    checked={item.isChecked}
                                                    disabled={item.isDisabled}
                                                    title={
                                                      item.availableSpots +
                                                      " spots left"
                                                    }
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor={
                                                      "tableDefaultCheck" +
                                                      columnIndex +
                                                      index
                                                    }
                                                  >
                                                    {" "}
                                                  </label>
                                                </>
                                              )}
                                            </div>
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </Table>
                        ) : null}
                        {(this.state.user_type === "admin" ||
                          this.state.user_type === "superadmin") &&
                        !selected_suite_id.length ? (
                          <div className="help-block">{``}</div>
                        ) : leftCredit <= 0 ? (
                          <div className="help-block">
                            {this.state.creditLimitMessage}
                          </div>
                        ) : null}
                      </div>
                    )}
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        <>
          {confirm_isopen ? (
            <ConfirmReservation
              showBrowserModal={confirm_isopen}
              closeModal={this.handleToogle}
              confirm_data={confirm_data}
              onSubmit={this.handleSubmit}
              isButtonDisable={!this.state.isButtonDisable}
            />
          ) : null}
        </>
      </div>
    );
  }
}

const mapStateToProps = ({
  CurrentPermitDetails,
  APIResponseDetails,
  UserProfileDetails,
  SuperAdminDetails,
  Logindetails,
}) => {
  const {
    currentCredits,
    usedCredits,
    allocatedCredits,
    usedAllocatedCredits,
    data_parked,
    multiple_permits,
    resident_permits,
    time_slot,
    date_slot,
    credit_30days_reports,
    credit_used_30days,
    single_credit_availability,
    residentList,
    date_range,
  } = CurrentPermitDetails;
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  const { time_slot_templates, templateCreditGroup } = SuperAdminDetails;
  const {
    credits,
    suite_id,
    property_id,
    user_type,
    available_spot,
    appConfig,
    globaleCredit,
    credit_type,
    day_availablity,
    evening_availability,
    night_availability,
    day,
    evening,
    night,
    company_id,
    property,
    timezone,
  } = UserProfileDetails;
  const { backgroundColor, semiAuthorizedUserProfile } = Logindetails;
  const { MainBackground: main_body } = backgroundColor;
  return {
    semiAuthorizedUserProfile,
    timezone,
    multiple_permits,
    time_slot,
    templateCreditGroup,
    globaleCredit,
    credit_30days_reports,
    credit_used_30days,
    date_slot,
    currentCredits,
    usedCredits,
    date_range,
    allocatedCredits,
    usedAllocatedCredits,
    single_credit_availability,
    time_slot_templates,
    data_parked,
    api_response,
    api_error_message,
    credits,
    suite_id,
    property_id,
    UserProfileDetails,
    user_type,
    company_id,
    available_spot,
    resident_permits,
    appConfig,
    api_success_message,
    credit_type,
    day_availablity,
    evening_availability,
    night_availability,
    day,
    evening,
    night,
    property,
    residentList,
    main_body,
  };
};

const mapStateToDispatch = {
  getCurrentPermits: CurrentPermitActions.getCurrentPermits,
  getCreditsIndividual: CurrentPermitActions.getCreditsIndividual,
  fetchResidentList: CurrentPermitActions.fetchResidentList,
  getCreditTemplateGroups: SuperAdminAction.getCreditTemplateGroups,
  getCreditsIndividualDetails: CurrentPermitActions.getCreditsIndividualDetails,
  getPastCreditsIndividual: CurrentPermitActions.getPastCreditsIndividual,
  AddPermits: CurrentPermitActions.AddPermits,
  getTimeSlot: CurrentPermitActions.getTimeSlot,
  getSettings: SuperAdminAction.getSettings,
  APIResponseSuccess: APIResponseActions.APIResponseSuccess,
  getCredits: CurrentPermitActions.getCredits,
  getPastCredits: CurrentPermitActions.getPastCredits,
  setResidentCredits: CurrentPermitActions.setResidentCredits,
  getResidentPermits: CurrentPermitActions.getResidentPermits,
  getResidents: CurrentPermitActions.setResidentCredits,
  setDomainHeader: SuperAdminAction.setDomainHeader,
  visitorPermitDelete: CurrentPermitActions.visitorPermitDelete,
};

export default connect(mapStateToProps, mapStateToDispatch)(VisitorPermit);
